import { get } from 'lodash'
import React from 'react'
import styled from 'styled-components'
import { Button, BUTTON_VARIANT } from 'components/Button'
import Icon from 'components/Icon'
import { Box, Flex } from 'components/Layout'
import { H3, Text } from 'components/Typography'
import { environment } from 'constants/environment'
import {
  COLOR_INTENT,
  FONT_SIZE,
  FONT_STACK,
  FONT_WEIGHT,
  mq,
  RADIUS,
  SPACE,
} from 'Theme'
import { type PublicProductQuery } from 'types/graphql-generated'

const ProductCustomContainer = styled(Flex)`
  background-color: ${COLOR_INTENT.PRODUCT_CUSTOM_OFFER.BACKGROUND};
  border-radius: ${RADIUS.PX_6};
  gap: ${SPACE.PX_20};
  ${mq.to.TABLET`
    gap: ${SPACE.PX_15};
  `}
`

interface ProductCustomProps {
  customContent: PublicProductQuery['product']['variants'][0]['customContent']
}

export const ProductCustom: React.FC<React.PWC<ProductCustomProps>> = ({
  customContent,
}) => {
  const customProductDescription = get(
    customContent,
    'customProductDescription',
    null
  )
  const customProductHeadline = get(
    customContent,
    'customProductHeadline',
    null
  )

  if (!customProductHeadline || !customProductDescription) {
    return null
  }

  const handleClickContactUs = () => {
    if (environment.CUSTOMER_SERVICE_FRAMEWORK === 'intercom') {
      window?.Intercom?.('show')
    } else {
      window?.FrontChat?.('show')
    }
  }

  return (
    <ProductCustomContainer
      py={SPACE.PX_30}
      px={{ MOBILE: SPACE.PX_20, TABLET: SPACE.PX_30 }}
      mt={SPACE.PX_18}
      flexDirection="column"
      alignItems="center"
    >
      <H3
        fontFamily={FONT_STACK.SERIF}
        fontWeight={FONT_WEIGHT.NORMAL}
        fontSize={{ MOBILE: FONT_SIZE.PX_25, TABLET: FONT_SIZE.PX_32 }}
        mb="0"
        textAlign="center"
      >
        {customProductHeadline}
      </H3>
      <Text
        fontFamily={FONT_STACK.SANS}
        fontSize={FONT_SIZE.PX_14}
        textAlign="center"
      >
        {customProductDescription}
      </Text>
      <Box>
        <Button
          variant={BUTTON_VARIANT.OUTLINE}
          icon={Icon.Send}
          onClick={handleClickContactUs}
          target="_blank"
          aria-label="Contact us"
        >
          Contact us
        </Button>
      </Box>
    </ProductCustomContainer>
  )
}
